import { useState } from "react";
import { validate } from "../utils/formValidation";

const useFormValidation = (infoFormValidationSchema) => {
  const [errors, setErrors] = useState({});

  const validateField = (name, value) => {    
    const fieldValidations = infoFormValidationSchema[name];
    if (fieldValidations) {
      const error = validate(value, fieldValidations);
      setErrors((prevErrors) => ({ ...prevErrors, [name]: error }));
    }
  };

  const validateAllFields = (formData, includeFields) => {
    const newErrors = {};
    for (const field in infoFormValidationSchema) {      
      if(includeFields.includes(field)){
        const error = validate(formData[field], infoFormValidationSchema[field]);
        if (error) newErrors[field] = error;
      }
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Returns true if no errors
  };

  return { errors, validateField, validateAllFields };
};

export default useFormValidation;
